/**
 * Payment Terms Constants
 */

export interface PaymentTerm {
  value: string;
  label: string;
  days: number | null;
}

export const PAYMENT_TERMS: PaymentTerm[] = [
  { value: 'due_on_receipt', label: 'Due on Receipt', days: 0 },
  { value: 'net_15', label: 'Net 15', days: 15 },
  { value: 'net_30', label: 'Net 30', days: 30 },
  { value: 'net_45', label: 'Net 45', days: 45 },
  { value: 'net_60', label: 'Net 60', days: 60 },
  { value: 'net_90', label: 'Net 90', days: 90 },
  { value: 'custom', label: 'Custom', days: null },
];

export const getPaymentDays = (paymentTerms: string, customDays?: number): number => {
  if (paymentTerms === 'custom') {
    return customDays || 0;
  }
  const term = PAYMENT_TERMS.find(t => t.value === paymentTerms);
  return term?.days || 30;
};

export const calculateDueDate = (issueDate: string, paymentTerms: string, customDays?: number): string => {
  const date = new Date(issueDate);
  const days = getPaymentDays(paymentTerms, customDays);
  date.setDate(date.getDate() + days);
  return date.toISOString().split('T')[0];
};
